import { Point } from '../math/geometry/point';
export class PointMap {
    deleteP(point) {
        return this.delete(point.x, point.y);
    }
    clear() {
        this.m.clear();
    }
    get size() {
        return this.m.size;
    }
    setxy(x, y, v) {
        this.m.set(getKey(x, y), v);
    }
    set(p, v) {
        this.setxy(p.x, p.y, v);
    }
    delete(x, y) {
        return this.m.delete(getKey(x, y));
    }
    hasxy(x, y) {
        return this.m.has(getKey(x, y));
    }
    has(p) {
        return this.hasxy(p.x, p.y);
    }
    getxy(x, y) {
        return this.m.get(getKey(x, y));
    }
    get(p) {
        return this.getxy(p.x, p.y);
    }
    constructor() {
        this.m = new Map();
    }
    *keys() {
        for (const p of this.m.keys()) {
            const parts = p.split(',');
            yield new Point(Number(parts[0]), Number(parts[1]));
        }
    }
    *[Symbol.iterator]() {
        for (const [p, v] of this.m) {
            const parts = p.split(',');
            yield [new Point(Number(parts[0]), Number(parts[1])), v];
        }
    }
    *values() {
        yield* this.m.values();
    }
}
function getKey(x, y) {
    return x.toString() + ',' + y.toString();
}
//# sourceMappingURL=PointMap.js.map